const cache = new Map<string, Intl.NumberFormat>();

export function numberFormat(options: Intl.NumberFormatOptions = {}): Intl.NumberFormat {
    const key = JSON.stringify(options);
    const cached = cache.get(key);
    if (cached) return cached;
    const format = new Intl.NumberFormat('it-IT', { useGrouping: 'always', ...options });
    cache.set(key, format);
    return format;
}

export default numberFormat;
